import Home from "./views/Home.vue";
import { NotAuthorized, NotFound } from "@modernary/mui/components/common";

// import loginRoutes from "./views/login/loginRoutes";
import { default as handlerRoutes, handlerRouteNames } from "./views/handler/handlerRoutes";
// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  notAuthorized: "NotAuthorized",
  ...handlerRouteNames,
};

/** @type {import('vue-router').RouterOptions['routes']} */
export const routes = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  ...handlerRoutes,
  // ...loginRoutes,
  { path: "/:path(.*)", component: NotFound },
];
